/**
 * Resolves a diagnostic placement band for a single subtopic.
 *
 * @param {Array<{ level: "1"|"2"|"3", correct: boolean }>} answers
 * @returns {"1"|"1-2"|"2"|"2-3"|"3"}
 */
export function resolveSubtopicBand(answers) {
  if (!Array.isArray(answers) || answers.length !== 3) {
    throw new Error("resolveSubtopicBand requires exactly 3 answers");
  }

  const key = answers
    .map(a => `${a.level}${a.correct ? "Y" : "N"}`)
    .join(" ");

  switch (key) {
    case "2Y 3Y 3Y":
      return "3";
    case "2Y 3Y 3N":
      return "2-3";
    case "2Y 3N 2Y":
      return "2";
    case "2Y 3N 2N":
    case "2N 1Y 2Y":
      return "1-2";
    case "2N 1Y 2N":
    case "2N 1N 1Y":
    case "2N 1N 1N":
      return "1";
    default:
      throw new Error(`Unrecognized diagnostic pattern: ${key}`);
  }
}
